/** Shared look of text-like controls. 16px text on phones keeps iOS from zooming in on focus. */
export const FIELD =
  'h-10 w-24 rounded-lg border border-neutral-300 bg-white px-2 text-base tabular-nums focus:border-accent md:h-8 md:text-sm';
